"use client";

import CheckboxInput from "@/components/UI/Input/Checkbox/Checkbox";
import { SearchFacetOption } from "@/lib/_search-providers/types";
import { FC } from "react";
import styles from "./Facet.module.scss";

export interface FacetProps {
	option: SearchFacetOption;
	onSelectFacet: (active: boolean) => void;
}
const Facet: FC<FacetProps> = ({ option, onSelectFacet }) => {
	return (
		<div className={styles.facet}>
			<CheckboxInput
				aria-label={option.label}
				label={
					<span>
						{option.label}{" "}
						<span className={styles.count}>({option.count})</span>
					</span>
				}
				checked={option.isSelected}
				role='checkbox'
				onClick={() => onSelectFacet(!option.isSelected)}
			/>
		</div>
	);
};

export default Facet;
